"use client"

import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className="faq-item bg-white p-6 mb-6 rounded-lg shadow-lg shadow-slate-100 transition-all duration-300 ease-in-out hover:shadow-xl hover:shadow-slate-200 cursor-pointer "
      onClick={() => setIsOpen(!isOpen)}
    >
      <div className="flex justify-between items-center">
        <h3 className={`text-xl font-semibold ${isOpen ? "text-secondary" : "text-primary"}`}>{question}</h3>
        <span className={`transition-transform duration-300 ${isOpen ? "rotate-180" : ""} text-amber-700`}>
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </div>
      <p
        className={`mt-4 text-gray-500 text-md transition-all duration-500 ease-in-out ${isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0 overflow-hidden"}`}
      >
        {answer}
      </p>
    </div>
  )
}

const RealEstateFAQs = () => {
  const faqsData = [
    {
      question: "What is the home buying process?",
      answer:
        "The home buying process typically involves getting pre-approved for a mortgage, house hunting, making an offer, getting a home inspection, finalizing your mortgage, and closing on the property.",
    },
    {
      question: "How much down payment do I need?",
      answer:
        "Down payment requirements vary, but typically range from 3% to 20% of the home's purchase price. Some loans, like VA loans, may offer zero down payment options for eligible buyers.",
    },
    {
      question: "What's the difference between a fixed-rate and adjustable-rate mortgage?",
      answer:
        "A fixed-rate mortgage has an interest rate that remains the same for the entire loan term. An adjustable-rate mortgage (ARM) has an interest rate that can change periodically based on market conditions.",
    },
    {
      question: "What is a home inspection?",
      answer:
        "A home inspection is a thorough examination of a property's condition, typically performed before purchase. It helps identify any existing or potential issues with the home's structure, systems, and components.",
    },
    {
      question: "What are closing costs?",
      answer:
        "Closing costs are fees associated with finalizing a real estate transaction. They typically include charges for services like appraisal, title search, attorney fees, and loan origination fees, usually totaling 2-5% of the home's purchase price.",
    },
    {
      question: "What is a real estate agent's role?",
      answer:
        "A real estate agent helps buyers and sellers navigate the real estate market. They assist with finding properties, negotiating prices, handling paperwork, and guiding clients through the entire buying or selling process.",
    },
  ]

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6 py-8">
      <div className="w-full  bg-white rounded-2xl shadow-2xl shadow-white p-10 ">
        <div className="flex items-center justify-center mb-8">
          <h2 className="text-4xl font-bold text-primary">Frequently ask questions</h2>
        </div>
        {faqsData.map((faq, index) => (
          <FAQItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </div>
  )
}

export default RealEstateFAQs

